import { UUID } from '@okcargo-apps/shared-domain';
import { MarkBatchImportAsCheckedCommand } from '@okcargo/command-processor';

export function transformFromIMarkBatchImportAsCheckedCommand(id: UUID): MarkBatchImportAsCheckedCommand {
  return {
    id: id,
  };
}
